var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container"},[_c('iframe',{staticClass:"iframe-preview",attrs:{"src":_vm.getURL}})])
}
var staticRenderFns = []

export { render, staticRenderFns }